"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderService = exports.m = void 0;
var tslib_1 = require("tslib");
var redraw_1 = tslib_1.__importDefault(require("mithril/api/redraw"));
var hyperscript_1 = tslib_1.__importDefault(require("mithril/hyperscript"));
var mobx_1 = require("mobx");
var index_1 = require("./index");
var log_service_1 = require("./log.service");
var trigger_1 = require("./util/trigger");
exports.m = hyperscript_1.default;
var RenderService = /** @class */ (function () {
    function RenderService() {
        this.__priority = 10;
    }
    RenderService.prototype.init = function () {
        this.boundRedraw = (0, redraw_1.default)(index_1.Services.Window.window);
    };
    RenderService.prototype.render = function (el, nodes) {
        this.boundRedraw.render(el, nodes);
    };
    RenderService.prototype.mount = function (el, component, name) {
        if (component == null) {
            if (el.$mobxDispose) {
                el.$mobxDispose();
                el.$mobxDispose = null;
            }
            return;
        }
        var trigger = new trigger_1.IkeTrigger(name);
        var lastRedraw = Date.now();
        var boundRedraw = this.boundRedraw;
        function renderFunction() {
            try {
                var startTime = Date.now();
                // Force watching the trigger,
                // This will allow us to manually trigger redraws when needed.
                trigger.observe();
                var sinceLastRedraw = startTime - lastRedraw;
                // VNodes need to be computed every time otherwise everything inside the component
                // will become un-observed on every redraw.
                var nodes = component.view();
                if (sinceLastRedraw < 16 || trigger.isTriggering) {
                    trigger.trigger();
                    return;
                }
                // Mithril redraw
                boundRedraw.render(el, nodes);
                lastRedraw = Date.now();
                var duration = lastRedraw - startTime;
                if (duration > 100) {
                    index_1.Services.Log.Logger.warn({ component: name, duration: duration }, 'Long redraw');
                    index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Performance, 'draw:slow', name, duration);
                }
            }
            catch (error) {
                log_service_1.Logger.error("Failed to render component ".concat(name));
                throw error;
            }
        }
        el.$mobxDispose = (0, mobx_1.autorun)(renderFunction, { name: "reaction:".concat(name) });
    };
    return RenderService;
}());
exports.RenderService = RenderService;
//# sourceMappingURL=render.service.js.map